import { render, staticRenderFns } from "./AddProperty.vue?vue&type=template&id=c62b845a&scoped=true&"
import script from "./AddProperty.vue?vue&type=script&lang=js&"
export * from "./AddProperty.vue?vue&type=script&lang=js&"
import style0 from "./AddProperty.vue?vue&type=style&index=0&id=c62b845a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62b845a",
  null
  
)

export default component.exports